import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'
import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import type { ConditionItem } from 'features/conditions/types/conditions.types'

type EditConditionVariables = {
	id: number
	data: Pick<ConditionItem, 'name'>
}

type UseEditConditionMutationProps = {
	onSuccess: () => void
}

export const useEditConditionMutation = ({ onSuccess }: UseEditConditionMutationProps) => {
	const { t } = useTranslation()
	const axiosPrivate = useAxiosPrivate()
	const queryClient = useQueryClient()

	const { mutate: editConditionMutation, isPending: isEditConditionLoading } = useMutation({
		mutationFn: ({ id, data }: EditConditionVariables) => {
			return axiosPrivate.patch(apiRoutes.condition(String(id)), data)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: queryKeys.conditions.all })
			useToast({ type: 'success', message: t('Condition edited') })()

			onSuccess()
		},
		onError: () => {
			useToast({ type: 'error', message: t('Something went wrong') })()
		}
	})

	return {
		editConditionMutation,
		isEditConditionLoading
	}
}
